module.exports = __webpack_public_path__ + "img/Live-data.5afe747e.png";